import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../constant/TYPE";
import Count from "./Count";
import Accuracy from "./Accuracy";
import Speed from "./Speed";

const AnsweringInfo = ( props ) => {

  const deviceInfo = useSelector( state => state.deviceInfo );

  const {
    QuestionCountAccentor,
    Timer
  } = props;

  return (
    <div className="header-qa-wrap">
      <QuestionCountAccentor><Count /></QuestionCountAccentor>
      <Timer />
      { TYPE.DEVICE.PHONE !== deviceInfo.type && <Accuracy /> }
      { TYPE.DEVICE.PHONE !== deviceInfo.type && <Speed /> }
    </div>
  );

};

AnsweringInfo.defaultProps = {
  QuestionCountAccentor : Fragment,
  Timer : Fragment
};

export default AnsweringInfo;
